module.exports = __webpack_public_path__ + "media/images/bg/mosaic/circle-0907e0aab13c7bccc2e5ae4e2a28e8ea.svg";